<template>
  <section class="backend-view">
    <BackendNavbar></BackendNavbar>
    <div class="table-content">
      <div class="img-container" v-if="$route.name === 'backend'">
        <img @contextmenu.prevent src="../../assets/new-image/VNA-LOGO-horiz-Tieng Viet.jpg" />
      </div>

      <router-view></router-view>
    </div>
  </section>
</template>
<script>
import BackendNavbar from '../../ui/BackendNavbar1.vue'
import store from '@/store'

export default {
  components: {
    BackendNavbar
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.isLoggedIn === false) {
      next(false)
    } else {
      next()
    }
  }
}
</script>

<style scoped>
  .backend-view {
    display: flex;
    background-color: white !important;
    /* min-height: 1100px; */
  }

  .table-content {
    padding: 0px 15px;
    flex: 1;
  }

  .table-content .img-container {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* .table-content img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
  } */
</style>
